'use strict';

import debug from "../qa/debug";
import {CINEMAMODE, getCinemaModeByName} from "../cinema/dimensions";
import tileCalculator from "../cinema/tileCalculator";

export default (tileContainerDom, scroller) => {
    const tileListView = {};

    const TILE_MARGIN = 16;
    const TILE_MARGIN_REDESIGN = 8;

    const IMPROVE_FABIS_USEREXPERIENCE_WHEN_ZOOMING_75PERCENT = 1;
    tileListView.domWrapper = {
        getCurrentScrollPositionPx: () => tileContainerDom.scrollLeft,
        setCurrentScrollPositionPx: (newPosition) => {
            tileContainerDom.scrollLeft = newPosition;
        },
        getContentWidthPx: () => tileContainerDom.scrollWidth,
        getSlidingWindowWidthPx: () => tileContainerDom.offsetWidth,
        getCinemaMode: () => tileContainerDom.getAttribute("data-cinema-mode")
    };

    const IMAGE_CONTAINER_PADDING = 4;

    tileListView.isAtLeftBorder = () => {
        const leftEdgePosition = 0;
        return Math.floor(tileListView.domWrapper.getCurrentScrollPositionPx()) === leftEdgePosition;
    };

    tileListView.isAtRightBorder = () => {
        const rightEdgePosition = tileListView.domWrapper.getContentWidthPx() - IMPROVE_FABIS_USEREXPERIENCE_WHEN_ZOOMING_75PERCENT;
        const visibleViewWidth = tileListView.domWrapper.getSlidingWindowWidthPx();
        const currentRightScrollPosition = (Math.ceil(tileListView.domWrapper.getCurrentScrollPositionPx()) + visibleViewWidth + TILE_MARGIN);
        return rightEdgePosition <= currentRightScrollPosition;
    };

    tileListView.fullyVisibleTilesPerPage = () => {
        const width = tileListView.domWrapper.getSlidingWindowWidthPx();
        const cinemaMode = tileListView.cinemaMode();

        switch (cinemaMode) {
            case CINEMAMODE.PORTRAIT:
            case CINEMAMODE.LANDSCAPE:
            case CINEMAMODE.MIXED:
            case CINEMAMODE.SQUARE:
                return cinemaMode.getNumberOfTiles(width)
            case CINEMAMODE.REDESIGN:
                return tileCalculator(width).getNumberOfTiles();
            default:
                debug.log("data-cinema-mode attribute not found or invalid");
                return CINEMAMODE.SQUARE.getNumberOfTiles(width)
        }
    };

    const tilesPerPage = () => {
        const halfVisibleTile = 0.5;
        return tileListView.fullyVisibleTilesPerPage() + halfVisibleTile;
    };

    tileListView.tileWidthPx = () => {
        if (tileListView.cinemaMode() === CINEMAMODE.REDESIGN) {
            const fullWidth = tileListView.domWrapper.getSlidingWindowWidthPx();
            let tileMargins = tilesPerPage() * TILE_MARGIN_REDESIGN;
            return (fullWidth - tileMargins) / tilesPerPage();
        }
        return tileListView.domWrapper.getSlidingWindowWidthPx() / tilesPerPage()
    };

    tileListView.cinemaMode = () => {
        return getCinemaModeByName(tileListView.domWrapper.getCinemaMode());
    };

    tileListView.firstVisibleTileIndex = () => {
        const scrolledToPx = tileListView.domWrapper.getCurrentScrollPositionPx();

        return Math.ceil(scrolledToPx / tileListView.tileWidthPx());
    };

    tileListView.scrollTo = (targetIndex, startedOrFinishedScrollingCallback) => {
        const quarterTileOffsetCorrection = (tileListView.tileWidthPx() / 4);
        const newScrollPosition = stayWithinBoundaries(targetIndex * tileListView.tileWidthPx() - quarterTileOffsetCorrection - IMAGE_CONTAINER_PADDING);

        const oldScrollPosition = tileListView.domWrapper.getCurrentScrollPositionPx();

        scroller.scrollAnimation(oldScrollPosition, newScrollPosition, tileListView.domWrapper.setCurrentScrollPositionPx, startedOrFinishedScrollingCallback);
    };

    tileListView.registerScrollHandler = (callback) => {
        tileContainerDom.addEventListener('scroll', callback);
    };

    const stayWithinBoundaries = (scrollPosition) => {
        const maxRightScrollPosition = tileListView.domWrapper.getContentWidthPx() - tileListView.domWrapper.getSlidingWindowWidthPx();
        const maxLeftScrollPosition = 0;
        scrollPosition = Math.max(maxLeftScrollPosition, scrollPosition);
        scrollPosition = Math.min(maxRightScrollPosition, scrollPosition);
        return scrollPosition;
    };

    return tileListView;
};